import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca563654"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "expand-panel"
}
const _hoisted_2 = { class: "row m-2" }
const _hoisted_3 = { class: "col-10 fs-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-2 text-end" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
    })
  ])
], -1))
const _hoisted_5 = {
  key: 1,
  class: "expand-panel"
}
const _hoisted_6 = { class: "row m-2" }
const _hoisted_7 = { class: "col-10 fs-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-2 text-end" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-chevron-up",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
    })
  ])
], -1))
const _hoisted_9 = {
  key: 2,
  class: "m-3 content"
}
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
    }, [
      (!_ctx.expanded)
        ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.question), 1),
              _hoisted_4
            ])
          ]))
        : (_openBlock(), _createElementBlock("button", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.item.question), 1),
              _hoisted_8
            ])
          ])),
      (_ctx.showContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", {
              innerHTML: _ctx.item.answer
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}